import { Phone } from "lucide-react";
import { cn } from "@/lib/utils";
import { CONTACT_PHONE_DISPLAY, CONTACT_PHONE_TEL_URL } from "@/lib/contact";

interface PhoneLinkProps {
  className?: string;
  showIcon?: boolean;
  children?: React.ReactNode;
}

/**
 * PhoneLink component that tracks clicks for Google Ads conversion
 * Use this component for all phone number links to ensure consistent tracking
 */
export default function PhoneLink({ 
  className, 
  showIcon = true, 
  children 
}: PhoneLinkProps) {
  const handleClick = () => {
    // Track phone click conversion in Google Ads
    if (typeof window !== 'undefined' && (window as any).gtag_report_phone_conversion) {
      (window as any).gtag_report_phone_conversion();
    }
  };

  return (
    <a
      href={CONTACT_PHONE_TEL_URL}
      onClick={handleClick}
      className={cn(
        "inline-flex items-center gap-2 transition-colors",
        className
      )}
    >
      {showIcon && <Phone className="w-5 h-5" />}
      {children || CONTACT_PHONE_DISPLAY}
    </a>
  );
}
